<template>

  <div class="row">
    <div class="col-md-12">
      <div class="card card-body printableArea"><h3>
        <b>Laporan Disposisi Grafik</b>
        </h3>
        <hr>
        <div class="row">
          <div class="col-md-12 justify-content-md-center">
           
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="row">
                <div>
                  <div class="card-body">
                    <h4 class="font-medium text-inverse">Grafik Jenis Naskah Dinas</h4>
                    <ul class="list-inline">
                      <li class="p-l-0">
                        <h6 class="text-muted"></h6>
                      </li>
                    </ul>
                    <div class="total-revenue4">
                      <line-chart :chart-data="lineJND"></line-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="row">
                <div>
                  <div class="card-body">
                    <h4 class="font-medium text-inverse">Grafik Bulan</h4>
                    <ul class="list-inline">
                      <li class="p-l-0">
                        <h6 class="text-muted"></h6>
                      </li>
                    </ul>
                    <div class="total-revenue4">
                      <line-chart :chart-data="lineBulan"></line-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="row">
                <div>
                  <div class="card-body">
                    <h4 class="font-medium text-inverse">Grafik Jenis Surat</h4>
                    <ul class="list-inline">
                      <li class="p-l-0">
                        <h6 class="text-muted"></h6>
                      </li>
                    </ul>
                    <div class="total-revenue4">
                      <line-chart :chart-data="lineJS"></line-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="row">
                <div>
                  <div class="card-body">
                    <h4 class="font-medium text-inverse">Grafik Unit Kerja Pengirim / Asal Surat</h4>
                    <ul class="list-inline">
                      <li class="p-l-0">
                        <h6 class="text-muted"></h6>
                      </li>
                    </ul>
                    <div class="total-revenue4">
                      <line-chart :chart-data="linePengirim"></line-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from "@/components/table/table";
import moment from 'moment';
import { RotateSquare5 } from "vue-loading-spinner";
import { gtTab, gtTabs } from "@/components/gtTabs";
import { LineChart, BarChart } from "@/components/chart";
import axios from 'axios';

export default {
  components: {
    RotateSquare5,
    Table,
    gtTab,
    gtTabs,
    "line-chart": LineChart,
    "bar-chart": BarChart
  },
  data() {
    return {
      start_date : moment().startOf('year').format('YYYY-MM-DD'),
      end_date : moment().endOf('year').format('YYYY-MM-DD'),
      tanggal : new Date().getDate()+'-'+(new Date().getMonth()+1)+'-'+new Date().getFullYear(),
      detail_jnd : {
        namajnd: this.$store.state.laporanDispositionInGrafik.items.finaldatajenissuratndnamajenis,
        totaljnd: this.$store.state.laporanDispositionInGrafik.items.finaldatajenissuratndtotaljenis
      },
      detail_bulan: {
        namabulan: this.$store.state.laporanDispositionInGrafik.items.finalbulannamabulan,
        totalbulan: this.$store.state.laporanDispositionInGrafik.items.finalbulantotalbulan
      },
      detail_js : {
        namajs: this.$store.state.laporanDispositionInGrafik.items.finaljenissuratnamajs,
        totaljs: this.$store.state.laporanDispositionInGrafik.items.finaljenissurattotaljs
      },
    };
  },
  computed: {
    items() {
      return this.$store.state.laporanDispositionInGrafik.items ? this.$store.state.laporanDispositionInGrafik.items.items : [];
    },
    chartDataJND(){
      let chartDataJND = {
        labels: [],
        datasets: [
          {
            backgroundColor: ["#55ce63", "#009efb", "#ffbc34", "#f62d51"],
            data: []
          }
        ]
      }
      return chartDataJND;
    },
    chartDataBulan(){
      let chartDataBulan = {
        labels: [],
        datasets: [
          {
            backgroundColor: ["#55ce63", "#009efb", "#ffbc34", "#f62d51"],
            data: []
          }
        ]
      }
      return chartDataBulan;
    },
    chartDataJS(){
      let chartDataJS = {
        labels: [],
        datasets: [
          {
            backgroundColor: ["#55ce63", "#009efb", "#ffbc34", "#f62d51"],
            data: []
          }
        ]
      }
      return chartDataJS;
    },
    chartDataUnit(){
      let chartDataUnit = {
        labels: [
          "Biasa",
          "Terbatas",
          "Rahasia"
        ],
        datasets: [
          {
            backgroundColor: ["#55ce63", "#009efb", "#ffbc34", "#f62d51"],
            data: [100, 100, 100, 100]
          }
        ]
      }
      return chartDataUnit;
    },
    lineJND(){
      // let vm = this;
      let lineJND = {
        labels: this.$store.state.laporanDispositionInGrafik.items.finaldatajenissuratndnamajenis,
        datasets: [
          {
            label: "Surat Masuk",
            data: this.$store.state.laporanDispositionInGrafik.items.finaldatajenissuratndtotaljenis,
            borderDash: [5, 5],
            borderWidth: 1,
            borderColor: "#55ce63",
            pointBorderColor: "#55ce63",
            backgroundColor: "rgba(85, 206, 99, 0.55)",
            pointBackgroundColor: "transparent"
          },
        ]
      }

      return lineJND;
    },
    lineBulan(){
      // let vm = this;
      let lineBulan = {
        labels: this.$store.state.laporanDispositionInGrafik.items.finalbulannamabulan,
        datasets: [
          {
            label: "Surat Masuk",
            data: this.$store.state.laporanDispositionInGrafik.items.finalbulantotalbulan,
            borderDash: [5, 5],
            borderWidth: 1,
            borderColor: "#55ce63",
            pointBorderColor: "#55ce63",
            backgroundColor: "rgba(85, 206, 99, 0.55)",
            pointBackgroundColor: "transparent"
          },
        ]
      }

      return lineBulan;
    },
    lineJS(){
      // let vm = this;
      let lineJS = {
        labels: this.$store.state.laporanDispositionInGrafik.items.finaljenissuratnamajs,
        datasets: [
          {
            label: "Surat Masuk",
            data: this.$store.state.laporanDispositionInGrafik.items.finaljenissurattotaljs,
            borderDash: [5, 5],
            borderWidth: 1,
            borderColor: "#55ce63",
            pointBorderColor: "#55ce63",
            backgroundColor: "rgba(85, 206, 99, 0.55)",
            pointBackgroundColor: "transparent"
          },
        ]
      }

      return lineJS;
    },
    linePengirim(){
      let linePengirim = {
        labels: this.$store.state.laporanDispositionInGrafik.items.finaldataunitnamaunit,
        datasets: [
          {
            label: "Surat Masuk",
            data: this.$store.state.laporanDispositionInGrafik.items.finaljenissurattotaljs,
            borderDash: [5, 5],
            borderWidth: 1,
            borderColor: "#55ce63",
            pointBorderColor: "#55ce63",
            backgroundColor: "rgba(85, 206, 99, 0.55)",
            pointBackgroundColor: "transparent"
          },
        ]
      }
      return linePengirim;
    },
    prints() {
      return this.$store.state.laporanDispositionInGrafik.items ? this.$store.state.laporanDispositionInGrafik.items.prints : [];
    },
    filters() {
      return this.$store.state.laporanDispositionInGrafik.items ? this.$store.state.laporanDispositionInGrafik.items.filters: {};
    },
    state() {
      return this.$store.state.laporanDispositionInGrafik;
    },
    forbidUpdate(){
      if(this.$store.state.profile.permissions.laporan_dispoin_grafik){
        return !this.$store.state.profile.permissions.laporan_dispoin_grafik.update;
      }
      return false;
    },
    forbidRead(){
      if(this.$store.state.profile.permissions.laporan_dispoin_grafik){
        return !this.$store.state.profile.permissions.laporan_dispoin_grafik.read;
      }
      return false;
    },
    forbidDel(){
      if(this.$store.state.profile.permissions.laporan_dispoin_grafik){
        return !this.$store.state.profile.permissions.laporan_dispoin_grafik.delete;
      }
      return false;
    }
  },
  mounted() {
    const state = {
      loaded: false,
      items: [],
      prints: [],
    };
    this.$store.commit("laporanDispositionInGrafik/STATE", state);
    this.get();
  },
  methods: {
    get(val) {
      this.$store.dispatch("laporanDispositionInGrafik/getLaporanDispositionInGrafik", val);
    },
    resetInput() {
      this.start_date = "";
      this.end_date = "";
      this.get(state);
    },
    pagination(params) {
      this.filterData(null, params);
    },
    filterData: function (event, params) {
      var val = {
        start_date: this.start_date,
        end_date: this.end_date
      }
      if(typeof(params) == "object" && params.constructor.name === "Object") {
        val = Object.assign(params, val);
      }
      this.get(val);
    },
    doDetail(val) {
      this.$store.dispatch("laporanDispositionInGrafik/onDetail", val);
    },
    doEdit(val) {
      this.$store.dispatch("laporanDispositionInGrafik/onEdit", val);
    },
    doDelete(val) {
      this.$store.dispatch("laporanDispositionInGrafik/submitDelete", val);
    },
  
  }
};
</script>
